import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoginStatusState } from '@core/login-status/store/states/login-status.state';
import { LoadLoginStatus } from '@core/login-status/store/actions/login-status.actions';

@Injectable({
  providedIn: 'root',
})
export class LoginStatusFacade {
  private readonly store = inject(Store);

  readonly isLoginDegradationBannerEnabled = this.store.selectSignal(LoginStatusState.isLoginDegradationBannerEnabled);

  loadLoginStatus(): void {
    this.store.dispatch(new LoadLoginStatus());
  }
}
